import React from "react";
import { Box, Typography } from "@mui/material";
import { useParams, useLocation } from "react-router-dom";
import SteminpeLeaderboardTopPlaySkill from "../../components/leaderboards/SteminpeLeaderboardTopPlaySkill";

const SteamTopParticipantSportLeaderboard = () => {
    // add orgType query parameter if needed, for example: ?org_type=primary    
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const orgType = searchParams.get('org_type') || 'all';
    return (
        <Box>
            <SteminpeLeaderboardTopPlaySkill orgType={orgType} />
        </Box>
    );
}

export default SteamTopParticipantSportLeaderboard;